import { useEffect } from "react";

/**
 * Injects a schema.org JSON-LD <script> into <head> so search engines and AI
 * assistants can accurately understand dynamic pages (e.g. individual vehicles).
 * Pass a plain object; it is re-rendered whenever `data` changes and removed on unmount.
 */
export default function JsonLd({ data }) {
    useEffect(() => {
        if (!data) return undefined;
        const el = document.createElement("script");
        el.type = "application/ld+json";
        el.text = JSON.stringify(data);
        document.head.appendChild(el);
        return () => {
            if (el.parentNode) el.parentNode.removeChild(el);
        };
    }, [data]);
    return null;
}
